import CssBaseline from '@mui/material/CssBaseline';
import GlobalStyles from '@mui/material/GlobalStyles';
import { ThemeProvider } from '@mui/material/styles';

import { createBrandMuiTheme } from 'reservations/brand/helpers/theme';
import useBrandData from 'reservations/brand/hooks/useBrandData';

type MuiThemeProviderProps = {
  children?: React.ReactNode;
};

const MuiThemeProvider = ({ children }: MuiThemeProviderProps) => {
  const { styles, fonts } = useBrandData();

  const theme = createBrandMuiTheme(styles, fonts);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <GlobalStyles styles={{ '.clover-footer': { display: 'none' } }} />
      {children}
    </ThemeProvider>
  );
};

export default MuiThemeProvider;
